<!--抄表配置，只有有配置信息的表才是计费表-->
<template>
	<div>
		<meterList ref="meterList" v-show="!nowMeter" class="full custom-scrollbar" @showDetails="nowMeter = $event" ></meterList>
		<meterDetails v-show="nowMeter" class="full custom-scrollbar" @closeDetails="nowMeter = undefined" :nowMeter="nowMeter" @updateMeter="nowMeter = $event,$refs.meterList.loadMeterList($refs.meterList.nowUnitId)"></meterDetails>
	</div>
</template>

<script>
	import meterList from './meterList.vue'
	import meterDetails from './meterDetails.vue'
	export default {
		components: {
			meterList,
			meterDetails
		},
		props: {},
		data() {
			return {
				nowMeter:undefined
			}
		},
		created() {},
		mounted() {},
		destroyed() {},
		computed: {},
		watch: {},
		methods: {
		}
	}
</script>

<style scoped>
	.full{
		width: 100%;
		height: 100%;
	}
</style>
